/**************************************************
 * Nombre:       Home_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Categoria from "../../Tarjetas/Tarjeta_Categoria";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import cate from '../../../Recursos/tmp_categoria.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Categorias = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{color: '#737373', fontSize: sCell ? 16 : 18, fontWeight: 400}}>
                            Descubre un mundo de opciones
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{color: '#252B42', fontSize: sCell ? 32 : 40, fontWeight: 800}}>
                            Nuestras categorias
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{color: '#737373', fontSize: sCell ? 16 : 18, fontWeight: 400}}>
                            Encuentra los productos perfectos
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: sCell ? 3 : 5,
                        arrows: true,
                        pagination: false,
                        width: '100%',
                        drag: 'false',
                        interval: 5000,
                        noDrag: true,
                        perMove: 1

                    }}
                >

                    {items.map((item, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <Tarjeta_Categoria item={item}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>

            </Grid>

        </Grid>
    )

}
export default Home_Categorias

const items = [cate, cate, cate, cate, cate, cate, cate]